import { indexOf } from 'lodash'

interface Props<T> {
  data: T[]
  column?: number
  gutter?: number
  itemExtraHeight?: number
  sizeLoader?: (arg: T) => number
}
/**
 * 我们这里用作品的width height原始比例去做
 * @param data 列表数据
 * @param column 列数
 * @param gutter 间距
 * @param itemExtraHeight 图片外的高度，减少计算误差
 * @param sizeLoader 高度/宽度
 * @returns length===column的二维数组
 */

export const useMasonry = <T>({
  data,
  column = 6,
  gutter = 12,
  itemExtraHeight = 0,
  sizeLoader,
}: Props<T>) => {
  const columnList: T[][] = new Array(column).fill([])
  const heightList: number[] = new Array(column).fill(0)
  const gutterWidth = (column - 1) * gutter
  const baseWidth = (1392 - gutterWidth) / column
  data?.map(it => {
    const minHeightColumn = indexOf(heightList, Math.min(...heightList))
    const height =
      Math.floor(baseWidth * (sizeLoader ? sizeLoader?.(it) : 1)) +
      itemExtraHeight +
      gutter
    heightList[minHeightColumn] = heightList[minHeightColumn] + height
    columnList[minHeightColumn] = [...columnList[minHeightColumn], it]
  })

  return {
    /**根据column组合的列表 */
    columnList: columnList,
    /**每一列的宽度 */
    columnWidth: `calc((100% - ${gutterWidth}px)/${column})`,
    /** 上下左右间距 */
    columnGutter: gutter,
  }
}
